<template>
    <div>
        <pagination-component
            :pagination="pagination"
            :key="'pagination-1-'+ (pagination.current_page ? pagination.current_page : 1) + pagination.total"
        ></pagination-component>
        <table class="table simple-table table-striped table-sm mb-0 table-bordered" style="font-size:0.8em;">
            <thead class="thead-dark">
            <tr>
                <th scope="col" rowspan="2" class="text-md-center align-middle">{{ $lang('ID') }}</th>
                <th scope="col" rowspan="2" class="text-md-center align-middle">{{ $lang('Nr zadania') }}</th>
                <th scope="col" colspan="2" class="text-md-center align-middle">{{ $lang('Czas') }}</th>
                <th scope="col" rowspan="2" class="text-md-center align-middle">{{ $lang('Temat') }}</th>
                <th scope="col" rowspan="2" class="text-md-center align-middle">{{ $lang('Status') }}</th>
                <th scope="col" rowspan="2" class="text-md-center align-middle">{{ $lang('Konsultant') }}</th>
                <th scope="col" colspan="2" class="text-md-center align-middle">{{ $lang('Ocena') }}</th>
                <th scope="col" rowspan="2" class="text-md-center align-middle" v-if="withComment">{{ $lang('Komentarz') }}</th>

            </tr>
            <tr>
                <th scope="col" class="text-md-center align-middle">{{ $lang('Zgłoszenie') }}</th>
                <th scope="col" class="text-md-center align-middle">{{ $lang('Zamknięcie') }}</th>

                <th scope="col" class="text-md-center align-middle">{{ $lang('Wartość') }}</th>
                <th scope="col" class="text-md-center align-middle">{{ $lang('Info') }}</th>
            </tr>
            </thead>
            <tbody>

            <tr v-if="pagination.total === 0" class="table-light">
                <th :colspan="withComment ? 10 : 9">{{$lang('Brak zgłoszeń.')}}</th>
            </tr>

            <template v-else v-for="(task, index) in pagination.data">

                <tr v-if="task.group_id && (index % 50 === 0 || task.group_id !== pagination.data[index-1].group_id)">
                    <th :colspan="withComment ? 10 : 9">
                        <span>{{ statistics[task.group_id].label }} </span>
                        (<span>{{$lang('liczba ocen') + ': ' + statistics[task.group_id].total}}</span>,
                        <span>{{$lang('średnia') + ': ' + statistics[task.group_id].avg}}</span>)
                    </th>
                </tr>

                <tr>
                    <td :data-title="$lang('ID')" class="align-middle">
                        <a :href="'/task/' + task.id" target="_blank">{{task.id}}</a>
                    </td>
                    <td :data-title="$lang('Nr zadania')" class="align-middle text-nowrap">
                        <a :href="jira_link + task.jira_id" target="_blank"> {{task.jira_id}} </a>
                    </td>
                    <td :data-title="$lang('Zgłoszenie')" class="text-md-center align-middle"><span>{{ task.created_at }}</span></td>
                    <td :data-title="$lang('Zamknięcie')" class="text-md-center align-middle"><span>{{ task.status_change }}</span></td>
                    <td :data-title="$lang('Temat')" class="align-middle"><span>{{ task.subject }}</span></td>
                    <td :data-title="$lang('Status')" class="align-middle">
                        <span :class="'badge badge-' + project_badge_prefix + task.status_id">{{task.status}}</span>
                    </td>
                    <td :data-title="$lang('Konsultant')" class="align-middle text-nowrap"><span>{{ task.consultant }}</span></td>
                    <td :data-title="$lang('Wartość')" class="text-md-center align-middle"><b>{{ task.rate }}</b></td>
                    <td :data-title="$lang('Info')" class="text-md-center align-middle"><b>{{ task.auto }}</b></td>
                    <td :data-title="$lang('Komentarz')" class="align-middle" v-if="withComment"><span>{{ task.comment }}</span> </td>
                </tr>

            </template>


            </tbody>
        </table>

        <pagination-component
            :pagination="pagination"
            :key="'pagination-2-'+ (pagination.current_page ? pagination.current_page : 1) + pagination.total"
        ></pagination-component>
    </div>
</template>

<script>
import PaginationComponent from "../../pagination-component.vue";

export default {
    name: "maintenance-service-summary-table",
    components: {PaginationComponent},
    props: {
        pagination: Object,
        statistics: Object | Array,
        withComment: Boolean,
        project_badge_prefix: String,
        jira_link: String
    },
    data() {
        return {
        }
    },
    methods: {

    },
    computed: {

    }
}
</script>
